import { Grid } from '@material-ui/core';
import React from 'react';
import FilterTogglebar from './FilterTogglebar';
import ArizonaView from './ArizonaView';

const ArizonaContainer = () => {
    return (
        <Grid container>
            <FilterTogglebar />
            <ArizonaView />
        </Grid>
    );
};

export default ArizonaContainer;